/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_calendar__cancel = /** @type {(inputs: {}) => string} */ () => {
	return `Löschen`
};

const en_calendar__cancel = /** @type {(inputs: {}) => string} */ () => {
	return `Delete`
};

const es_calendar__cancel = /** @type {(inputs: {}) => string} */ () => {
	return `Borrar`
};

const fr_calendar__cancel = /** @type {(inputs: {}) => string} */ () => {
	return `Effacer`
};

const it_calendar__cancel = /** @type {(inputs: {}) => string} */ () => {
	return `Cancellare`
};

const nl_calendar__cancel = /** @type {(inputs: {}) => string} */ () => {
	return `Verwijder`
};

const pt_calendar__cancel = /** @type {(inputs: {}) => string} */ () => {
	return `Apagar`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const calendar__cancel = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.calendar__cancel(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("calendar__cancel", locale)
	if (locale === "de") return de_calendar__cancel(inputs)
	if (locale === "en") return en_calendar__cancel(inputs)
	if (locale === "es") return es_calendar__cancel(inputs)
	if (locale === "fr") return fr_calendar__cancel(inputs)
	if (locale === "it") return it_calendar__cancel(inputs)
	if (locale === "nl") return nl_calendar__cancel(inputs)
	return pt_calendar__cancel(inputs)
};